import { render } from "./ViewInvoices.vue?vue&type=template&id=2edbc946"
import script from "./ViewInvoices.vue?vue&type=script&lang=js"
export * from "./ViewInvoices.vue?vue&type=script&lang=js"

import "./ViewInvoices.vue?vue&type=style&index=0&id=2edbc946&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__